/* eslint-disable no-param-reassign */
import { createAsyncThunk } from '@reduxjs/toolkit';
import { NEW_PATH_DELIMITER } from '@picsio/db/src/constants';
import { makeTree, setField } from '../helpers/savedSearches';

export const move = createAsyncThunk(
  'savedSearches/move',
  async (
    { _id, path },
    {
      extra: {
        sdk, Logger, Toast, localization: l10n, showDialogAsync,
      },
      getState,
    },
  ) => {
    try {
      const { all } = getState().savedSearches;
      const search = all.find((ss) => ss._id === _id);
      if (search?.path) {
        // we need to check is there any saved searches in the same group, if yes - we will show different message in the dialog
        const pathWithoutName = search.path.split(NEW_PATH_DELIMITER).slice(0, -1).join(NEW_PATH_DELIMITER);
        const hasSiblings = all.some((ss) => ss._id !== _id && (ss.path || '').startsWith(pathWithoutName + NEW_PATH_DELIMITER));
        if (!hasSiblings) {
          try {
            Logger.log('UI', 'ConfirmDeleteSavedSearch');
            await showDialogAsync({
              title: l10n.TAGSTREE.titleMoveSavedSearchAndDeleteGroup,
              text: l10n.TAGSTREE.textMoveSavedSearchAndDeleteGroup(pathWithoutName.split(NEW_PATH_DELIMITER).pop()),
              textBtnOk: l10n.TAGSTREE.textMove,
              textBtnCancel: l10n.DIALOGS.btnCancel,
            }).promise;
          } catch (error) {
            // Do nothing, user just closed the dialog
            return null;
          }
        }
      }
      await sdk.savedSearches.move(_id, path || '');

      return { _id, path, userId: getState().user._id };
    } catch (error) {
      Logger.error(new Error('Can not move saved search'), { error }, [
        'MoveSavedSearchesFailed',
        { errorMessage: (error && error.message) || 'NoMessage' },
      ]);

      Toast('Error moving saved search', { type: 'error' });

      throw error;
    }
  },
);

export const reducer = (builder) => {
  builder.addCase(
    move.pending,
    (state, { meta: { arg: { _id } } }) => {
      state.tree = setField(state.tree, _id, 'isBusy', true);
    },
  ).addCase(
    move.fulfilled,
    (state, { meta: { arg: { _id } }, payload }) => {
      if (!payload) {
        state.tree = setField(state.tree, _id, 'isBusy', false);
        return;
      }

      const { path, userId } = payload;
      state.all = state.all.map((ss) => {
        if (ss._id !== _id) return ss;
        return { ...ss, path: `${path || ''}${NEW_PATH_DELIMITER}name` };
      });
      state.tree = makeTree(state.all, userId, state.searchQuery);
    },
  ).addCase(
    move.rejected,
    (state, { error, meta: { arg: { _id } } }) => {
      state.error = error;
      state.tree = setField(state.tree, _id, 'isBusy', false);
    },
  );
};
